exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subtitle[data-v-6b70d374]{line-height:32px;color:rgba(0,0,0,.54)\n}\n.select-loader[data-v-6b70d374]{margin-top:25px\n}\n.validation-error-message[data-v-6b70d374]{width:100%;margin:10px 0;padding:15px;background-color:#ff5722;color:#ebfaff;font-size:1.1em\n}\n.validation-error-message .md-icon[data-v-6b70d374]{margin-top:-2px;margin-right:5px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6b70d374","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Dfp.vue
// module id = 142
// module chunks = 0